import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=0cd60897&scoped=true"
import script from "./Curriculum.vue?vue&type=script&lang=js"
export * from "./Curriculum.vue?vue&type=script&lang=js"
import style0 from "./Curriculum.vue?vue&type=style&index=0&id=0cd60897&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd60897",
  null
  
)

export default component.exports